<template>
    <div id="frame-practicien">
        <h1>Droits ADRI</h1>
        <div>
            <div id="container-droitsADRI">
                <div class="general-sous-menu">
                    <h3>Mode du service d'acquisition des droits</h3>
                    <div class="general-group">
                        <input type="radio" />
                        <label>Lancement Systématique</label>
                    </div>
                    <div class="general-group">
                        <input type="radio" name="modeAcquisionDesDroits" />
                        <label>Lancement ciblé</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    @import 'parametre.css';
</style>

<script>
    import { defineComponent } from 'vue';

    export default defineComponent({
        components: {
            //Les composants
        },
        data: function () {
            return {
                message: 'Droits ADRI'
            }
        },

        computed: {

        },

        methods: {

        },

        props: {

        },
        mounted() {

        }

        ,
        created() {

        }

    });
</script>